import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import {Attribute, AttributeCondition} from "../metadata/api/attribute";
import { getOptionsForAttr } from './coderefs';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function BILimitSelector({attr, additionalOptions, dataType, mutuallyExclusive, ...props}) {

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  const formContext = useContext(FormContext);
  let attribute = formContext.metadata[attr];
  
  let allOptions = getOptionsForAttr(attribute).list;
  let limitOptions = allOptions;

  let disabled = false;

  if (additionalOptions && additionalOptions.length) {
    limitOptions = [...limitOptions, ...additionalOptions];
  }

  if(line.biLimit == ""){
    line.biLimit = "100000/300000";
    props.value = "100000/300000";
  }

  if(dataType && dataType === 'SelectUpdate'){
    let selected = null;
    let children = limitOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>);
    const options = React.Children.map(children, el => {
        if (!el.props) {
          return null;
        }
        const obj = {
          label: el.props.children,
          value: el.props.value
        };
        if (el.props.value === props.value) {
          selected = obj;
        }
        return obj;
    });
    
    const actions = useContext(ApplicationActionsContext);
    const { setValueByAttr, getValueByAttr } = formContext;
    const previousValue = selected;
    const [selectedValue, setSelectedValue] = useState(previousValue);
    
    const handleChange = (selected) => {
      setValueByAttr(attr, selected.value);
      setSelectedValue(selected);

      if(mutuallyExclusive == "true"){
        if(!(line.umbiLimit == "0" && line.uimbiLimit == "0")){
          if(line.umbiLimit == "0"){
            line.uimbiLimit = line.biLimit
          }
          if(line.uimbiLimit == "0"){
            line.umbiLimit = line.biLimit
          }
        }
      }

      actions.saveApplication();
    };

    return <Select
        {...props}
        isDisabled={disabled}
        aria-label="Select"
        styles={customStylesUpdater}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={options}
        value={selected}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
  }
  return <PortalSelect {...props}>
    {
      options.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

function optionIsValid(optionValue, compValue){
  if( optionValue.includes('/') && compValue.includes('/') ) {
    const optionValueArray = optionValue.split('/');
    const compValueArray = compValue.split('/');
    if( parseInt(optionValueArray[0]) < parseInt(compValueArray[0]) ) {
      return true;
    }
    else if( parseInt(optionValueArray[0]) == parseInt(compValueArray[0]) ) {
      if( parseInt(optionValueArray[1]) <= parseInt(compValueArray[1]) ) {
        return true;
      }
    }
    return false;
  }
  else if( (optionValue.includes('/') && !compValue.includes('/')) || (!optionValue.includes('/') && compValue.includes('/')) ) {
    return false;
  }
  else {
    if( parseInt(optionValue) <= parseInt(compValue) ) {
      return true;
    }
    return false;
  }
  return false;
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

BILimitSelector.schema = BASIC_ELEMENT_SCHEMA;